<template>
  <div>
    <div class="admin-container">
      <!--顶部工具栏-->
      <div class="admin-head-container">
        <el-button class="filter-item" size="mini" type="primary" icon="el-icon-plus" @click="add">新增产品</el-button>
      </div>

      <!--表格-->
      <el-table v-loading="loading" :data="data" size="small" style="width: 100%;">
        <!--产品名称-->
        <el-table-column label="产品名称" width="200">
          <template slot-scope="scope">
            <span style="font-size: 20px">{{ scope.row['product_name'] }}</span>
          </template>
        </el-table-column>
        <!--审核状态-->
        <el-table-column label="审核状态" width="80" align="center">
          <template slot-scope="scope" style="font-size: 18px">
            <el-tag v-if="scope.row.state === '1'" type="success">已审核</el-tag>
            <el-tag v-else-if="scope.row.state === '0'" type="danger">未审核</el-tag>
          </template>
        </el-table-column>
        <!--首页展示-->
        <el-table-column label="首页展示" width="80" align="center">
          <template slot-scope="scope" style="font-size: 18px">
            <el-tag v-if="scope.row.home_view === '1'" type="">展示</el-tag>
            <el-tag v-else-if="scope.row.home_view === '0'" type="warning">不展示</el-tag>
          </template>
        </el-table-column>
        <!--产品图片-->
        <el-table-column label="产品图片" width="250" align="center">
          <template slot-scope="scope">
            <el-carousel height="160px" :interval="8000">
              <el-carousel-item v-for="(item, i) in scope.row['image_paths']" :key="i">
                <img :src="item" alt="" class="product-img">
              </el-carousel-item>
            </el-carousel>
          </template>
        </el-table-column>
        <!--图片数量-->
        <el-table-column label="图片数量" width="90" align="center">
          <template slot-scope="scope">
            <span style="font-size: 20px">{{ scope.row['image_paths'].length }}张</span>
          </template>
        </el-table-column>
        <!--产品简介-->
        <el-table-column label="产品简介">
          <template slot-scope="scope">
            {{delHtmlTag(scope.row['product_desc'])}}
          </template>
        </el-table-column>
        <!--操作-->
        <el-table-column label="操作" width="160px" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="edit(scope.row)"
                       plain style="margin-bottom: 8px;">编辑</el-button>
            <br/>
            <el-popover
              :ref="scope.row['product_id']"
              placement="top"
              width="180">
              <p>确定删除本条数据吗？</p>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="$refs[scope.row['product_id']].doClose()">取消</el-button>
                <el-button :loading="delLoading" type="primary" size="mini" @click="subDelete(scope.row['product_id'])">确定
                </el-button>
              </div>
              <el-button slot="reference" type="danger" plain icon="el-icon-delete" size="mini">删除</el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--新增、编辑表单-->
    <product-form ref="form" :is-add="isAdd" :init="init"/>
  </div>
</template>

<script>
import { GetRequest } from '@/api/common'
import { deleteProduct } from '@/api/product'
import { delHtmlTag } from '@/utils/index'
import ProductForm from '@/views/AdminProduct/productForm'
export default {
  name: 'AdminProduct',
  components: { ProductForm },
  data () {
    return {
      loading: false,
      delLoading: false,
      data: [],
      query: {},
      url: '',
      params: {},
      time: 100,
      isAdd: false,
      page: 1,
      size: 10,
      total: 0
    }
  },
  created () {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    delHtmlTag,
    /**
     * @description 初始化之前参数设定
     * @returns {boolean}
     */
    beforeInit () {
      this.url = 'api/product'
      this.params = { type: 'list' }
      return true
    },
    /**
     * @description 初始化
     * @returns {Promise<undefined|*|Promise<unknown>>}
     */
    async init () {
      if (!await this.beforeInit()) {
        return
      }
      return new Promise((resolve, reject) => {
        this.loading = true
        GetRequest(this.url, this.params).then(res => {
          if (res.status === 200) {
            this.data = res.body
            setTimeout(() => {
              this.loading = false
            }, this.time)
            resolve(res)
          } else {
            this.loading = false
            reject(res.msg)
          }
        }).catch(err => {
          this.loading = false
          reject(err)
        })
      })
    },
    /**
     * @description 添加产品
     */
    add () {
      this.isAdd = true
      this.$refs.form.dialog = true
    },
    /**
     * @description 编辑产品
     * @param row
     */
    edit (row) {
      this.isAdd = false
      this.$refs.form.form = {
        product_id: row.product_id,
        product_name: row.product_name,             // 必传，产品名称
        category_id: '1',             // 必传，目前传‘1’
        state: Number(row.state),                     // 必传，0未审核，1审核通过
        home_view: Number(row.home_view),                 // 必传，首页展示，0不展示，1展示
        md_product_desc: '',          // 产品描述md
        html_product_desc: '',        // 产品描述html
        md_product_intro: '',         // 产品介绍md
        html_product_intro: '',       // 产品介绍html
        md_product_params: '',        // 产品参数md
        html_product_params: ''       // 产品参数html
      }
      this.$store.commit('set_md_product_desc', row.md_product_desc)
      this.$store.commit('set_html_product_desc', row.product_desc)
      this.$store.commit('set_md_product_intro', row.md_product_intro)
      this.$store.commit('set_html_product_intro', row.product_intro)
      this.$store.commit('set_md_product_params', row.md_product_params)
      this.$store.commit('set_html_product_params', row.product_params)
      this.$refs.form.dialog = true
    },
    /**
     * @description 删除产品
     * @param productId
     */
    subDelete (productId) {
      this.delLoading = true
      deleteProduct(productId).then(res => {
        if (res.status === 200) {
          this.delLoading = false
          this.$refs[productId].doClose()
          this.init()
          this.$notify({
            title: '删除成功',
            type: 'success',
            duration: 3000
          })
        } else {
          this.delLoading = false
          this.$refs[productId].doClose()
          this.$notify({
            title: '删除错误',
            type: 'error',
            message: res.msg,
            duration: 3000
          })
        }
      }).catch(err => {
        console.log(err)
        this.delLoading = false
        this.$refs[productId].doClose()
        this.$notify({
          title: '删除错误',
          type: 'error',
          message: err,
          duration: 3000
        })
      })
    }
  }
}
</script>

<style>
  .el-tooltip__popper {
    max-width: 800px;
  }
  .product-img {
    width: inherit;
    height: inherit;
    object-fit: contain;
  }
</style>
